<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card class="card-profile mt--300" no-body shadow>
          <div class="px-4">
            <div v-if="state === 0" class="text-center mt-5">
              <h3>لطفا چند لحظه صبر کنید</h3>
              <br/>
            </div>
            <div v-else-if="state === 1" class="text-center mt-5">
              <h3>باز کردن پیام خصوصی</h3>

              <p v-if="expireType===0" class="mt-4" style="text-align: center">
                این پیام بعد از باز شدن به صورت خودکار از بین خواهد رفت.
              </p>
              <p v-else class="mt-4" style="text-align: center"><!--TODO convert digits to persian-->
                این پیام بعد از {{ expireType }} ساعت به صورت خودکار از بین خواهد رفت.
              </p>

              <base-input v-if="hasPassword" v-model="password" alternative class="xxx" placeholder="کلمه عبور"/>

              <base-alert v-if="showError" icon="ni ni-support-16" type="danger">
                <span slot="text"><strong>خطا! </strong>{{ error }}</span>
              </base-alert>

              <div/>
              <br>

              <base-button type="primary" @click="openMessage">باز کردن پیام</base-button>
              <base-button type="neutral" @click="goHome">بعدا</base-button>

              <div/>
              <br>

            </div>
            <div v-else-if="state === 2" class="text-center mt-5">
              <h3>مشاهده پیام خصوصی</h3>

              <div class="h6 mt-4" style="text-align: right">محتوای پیام</div>

              <base-input class="mb-4">
                <textarea v-model="text" class="form-control form-control-alternative" cols="80"
                          placeholder="متن پیام" readonly rows="6"></textarea>
              </base-input>

              <div/>
              <br>

              <base-button type="neutral" @click="goHome">بستن</base-button>

              <div/>
              <br>

            </div>
            <div v-else class="text-center mt-5">
              <h3>خطا</h3>

              <p class="mt-4" style="text-align: center">
                این پیام منقضی شده یا وجود ندارد.
              </p>

              <base-button type="neutral" @click="goHome">بعدا</base-button>

              <div/>
              <br>

            </div>

          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
import axios from "axios";

export default {
  components: {
    Inputs,
  },
  data() {
    return {
      state: 0, //0:Wait 1:NotOpened 2:Opened else:NotExist
      expireType: 0,
      hasPassword: false,
      password: '',
      text: '',
      showError: false,
      error: '',
    }
  },
  mounted() {
    const formData = new FormData()
    formData.append('h', this.$route.params.hash)

    const headers = {'Content-Type': 'multipart/form-data'}
    axios.post(`${process.env.VUE_APP_API_ROOT}/get-private-message-info_v1`, formData, {headers})
        .then(res => {
          if (res.status === 200) {
            if (res.data.r === 1) {
              this.state = 1
              this.hasPassword = res.data.p
              this.expireType = res.data.e
            } else if (res.data.r === 2) {
              this.state = 3
            } else {
              this.error = 'متاسفانه خطایی غیرمنتظره رخ داد'
              this.showError = true
            }
          } else {
            this.error = 'متاسفانه خطایی رخ داد'
            this.showError = true
          }
        })
  },
  methods: {
    goHome() {
      this.$router.push({name: 'private-message'})
    },
    openMessage() {
      this.showError = false

      const formData = new FormData()
      formData.append('h', this.$route.params.hash)
      formData.append('mp', this.password)

      const headers = {'Content-Type': 'multipart/form-data'}
      axios.post(`${process.env.VUE_APP_API_ROOT}/get-private-message_v1`, formData, {headers})
          .then(res => {
            if (res.status === 200) {
              if (res.data.r === 1) {
                this.state = 2
                this.text = res.data.m
              } else if (res.data.r === 2) {
                this.state = 3
              } else if (res.data.r === 3) {
                this.error = 'کلمه عبور اشتباه است'
                this.showError = true
              } else {
                this.error = 'متاسفانه خطایی غیرمنتظره رخ داد'
                this.showError = true
              }
            } else {
              this.error = 'متاسفانه خطایی رخ داد'
              this.showError = true
            }
          })
    }
  }
};
</script>

<style>
.xxx input::-webkit-input-placeholder { /* WebKit browsers */
  text-align: right;
}

.xxx input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-align: right;
}

.xxx input::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-align: right;
}

.xxx input:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-align: right;
}

.xxx input {
  text-align: left;
  direction: ltr;
}
</style>
